import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpApi from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n
  .use(HttpApi) // Charge les fichiers de traduction via HTTP
  .use(LanguageDetector) // Détecte la langue du navigateur
  .use(initReactI18next) // Passer instance de i18next à react-i18next.
  .init({
    keySeparator: '.',
    supportedLngs: ['en', 'fr'],
    fallbackLng: 'en',
    load: 'languageOnly',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  })

i18n.on('languageChanged', (lng) => {
  const code = (lng || 'en').slice(0, 2).toLowerCase()
  localStorage.setItem('i18nextLng', code === 'fr' ? 'fr' : 'en')
})

export default i18n
